export default "__VITE_ASSET__CpssBpfu__"